'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredValidator = undefined;

var _reactIntl = require('react-intl');

var _verify = require('helpers/verify');

var messages = (0, _reactIntl.defineMessages)({
  required: {
    id: 'validators.required',
    defaultMessage: 'This field is required.'
  }
});

var requiredValidator = exports.requiredValidator = function requiredValidator(val) {
  if ((0, _verify.isBlank)(val)) {
    return messages.required;
  }
};